import React from 'react';
import Hero from './components/IQAC/audited-statement/Hero';
import Main from './components/IQAC/audited-statement/Main';

const IqacAuditedStatement = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacAuditedStatement;